import React, { Component } from 'react';
import '../css/validations.css'
import {
    ChangePasswordModal,
    SearchEmployeeModal,
} from "./index";

const EMAIL_FORMAT = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
const FIRSTNAME_FORMAT = /^[a-zA-ZÀ-ÿ\s]{3,15}$/;
const LASTNAME_FORMAT = /^[a-zA-ZÀ-ÿ\s]{3,35}$/;
const PHONE_FORMAT = /^\d{10,10}$/;
const PC_FORMAT = /^\d{5,5}$/;

class EmployeeModal extends Component {

    refreshModel = employeeModel => {
        const {refreshModel} = this.props;
        refreshModel(employeeModel);
    };

    CreateEmployee = () => {
        const {sendModel, employeeModel} = this.props;
        this.ValidateAll();
        sendModel(employeeModel);
    };

    cancelEditMode = () => {
        const {cancelEditMode} = this.props;
        cancelEditMode();
    };

    AcceptEditMode = () => {
        const {acceptEditMode, employeeModel} = this.props;
        acceptEditMode(employeeModel);
        
    };

    ChangeFirstName = event => {
        const {employeeModel} = this.props;
        employeeModel.FirstName = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    GetEmployee = async () => {
        const {SearchEmployee} = this.props;
        SearchEmployee();
    };

    ChangeLastName = event => {
        const {employeeModel} = this.props;
        employeeModel.LastName = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    Change_eMail = event => {
        const {employeeModel} = this.props;
        employeeModel.eMail = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeActive = value => {
        const {employeeModel} = this.props;
        employeeModel.Active = value;
        this.refreshModel(employeeModel);
    };

    ChangeRole = event => {
        const {employeeModel} = this.props;
        employeeModel.Role = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangePassword = event => {
        const {employeeModel} = this.props;
        employeeModel.Password = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeSucursal = event => {
        const {employeeModel} = this.props;
        employeeModel.Sucursal = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeCardCode = event => {
        const {employeeModel} = this.props;
        employeeModel.CardCode = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeCaja = event => {
        const {employeeModel} = this.props;
        employeeModel.Caja = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    //#region DIRECCIONES
    ChangeWorkStreet = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkStreet = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };
    
    ChangeWorkStreetNumber = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkStreetNumber = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkBlock = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkBlock = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkBuildingFloorRoom = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkBuildingFloorRoom = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkZipCode = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkZipCode = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkCity = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkCity = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkCounty = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkCounty = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkStateCode = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkStateCode = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeWorkCountryCode = event => {
        const {employeeModel} = this.props;
        employeeModel.WorkCountryCode = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeStreet = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeStreet = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeStreetNumber = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeStreetNumber = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeBlock = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeBlock = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeBuildingFloorRoom = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeBuildingFloorRoom = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeZipCode = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeZipCode = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeCity = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeCity = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeCounty = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeCounty = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeState = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeState = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeHomeCountry = event => {
        const {employeeModel} = this.props;
        employeeModel.HomeCountry = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };
    //#endregion DIRECCIONES

    ChangeGender = event => {
        const {employeeModel} = this.props;
        employeeModel.Gender = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeDateOfBirth = event => {
        const {employeeModel} = this.props;
        employeeModel.DateOfBirth = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeMobilePhone = event => {
        const {employeeModel} = this.props;
        employeeModel.MobilePhone = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };
    
    ValidateFirstName = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_FirstName');
        let text= document.querySelector(`#grupo__firstName .form__input-error`);
        let require= document.querySelector(`#grupo__firstName .form__input-void`);
        if (!employeeModel.FirstName == ''){
            if (!FIRSTNAME_FORMAT.test(employeeModel.FirstName)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");           
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateType = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('selectRole');
        let require= document.querySelector(`#grupo__selectRole .form__input-void`);
        if (!employeeModel.Role == ''){
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            require.classList.remove('form__input-void-active');
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');

        }
    }

    ValidatePassword = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_Password');
        let require= document.querySelector(`#grupo__password .form__input-void`);
        if (!employeeModel.Password == ''){
            
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            require.classList.remove('form__input-void-active');
            
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
            
        }
    }

    ValidateLastName = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_LastName');       
        let text= document.querySelector(`#grupo__lastName .form__input-error`);
        let require= document.querySelector(`#grupo__lastName .form__input-void`);
        if (!employeeModel.LastName == ''){
            if (!LASTNAME_FORMAT.test(employeeModel.LastName)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");           
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateE_mail = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_eMail');
        let text= document.querySelector(`#grupo__email .form__input-error`);
        let require= document.querySelector(`#grupo__email .form__input-void`);
        if (!employeeModel.eMail == ''){
            if (!EMAIL_FORMAT.test(employeeModel.eMail)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");           
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        }else{
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");           
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
        }
    }

    ValidatePhone = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_Phone');
        let text= document.querySelector(`#grupo__phone .form__input-error`);
        if (!PHONE_FORMAT.test(employeeModel.MobilePhone)){
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            text.classList.add('form__input-error-active');
        }else{
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            text.classList.remove('form__input-error-active');
        }
    }
    ValidatePostalCode = async () => {
        const {employeeModel} = this.props;
        let element= document.getElementById('User_PostalCode');
        let text= document.querySelector(`#grupo__pc .form__input-error`);
        if (!employeeModel.WorkZipCode == ''){
            if (!PC_FORMAT.test(employeeModel.WorkZipCode)){
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                text.classList.add('form__input-error-active');
            }else{
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                text.classList.remove('form__input-error-active');
            }
        }else{
            element.classList.remove('form__group-incorrect');
            element.classList.add("form__group-correct");
            text.classList.remove('form__input-error-active');
        }
    }

    ValidateAll = async()=>{
        this.ValidateFirstName();
        this.ValidateLastName();
        this.ValidateE_mail();
        this.ValidateType();
        this.ValidatePassword();
    }

    renderEditButton = () => {
        const {AcceptEdit, action, editMode} = this.props;
        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{backgroundColor: 'transparent', color: '#000'}}
                    className="btn btn-editar"
                    onClick={AcceptEdit}>
                    <i className="fas fa-edit  fa-lg"/>
                    Editar
                </button>
            );
        }
    };

    renderEmployeeHeader = () => {
        const {
            action,
            editMode,
            employeeModel,
            EyeVisibility,
            typeVisibility,
            sucursales,
            OpenChangePasswordModal,
            showSearchEmployeeModal,
            CloseSearchEmployeeModal,
            employees,
            SearchOneEmployee,
        } = this.props;
        
        let ListPartner = [];
        if(sucursales.length > 0 ){
            for (let index = 0; index < sucursales.length; index++) {
                const element = sucursales[index];
                if(Number(employeeModel.Sucursal) === element.pk_Sucursal){
                    ListPartner = element.ListPartners
                }
            }
        }
        
        return (
            <div >
                <div className="row">
                    {/*NOMBRE DE EMPLEADO*/}
                    <div className="col-sm-6 mb-3" id="grupo__firstName">
                        <div className="input-group" >
                            <div className="input-group-prepend form__group-input">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                            </div>
                                <input type="text" className="form-control form__input"
                                    id="User_FirstName"
                                    disabled={(action === 2 && !editMode) ? true : false}
                                    onChange={this.ChangeFirstName}
                                    value={employeeModel.FirstName ? employeeModel.FirstName : ""}
                                    onBlur={this.ValidateFirstName}/>
                            <button
                                type="button"
                                style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                className="input-group-text"
                                data-toggle="modal" data-target="#searchEmployeeModal"
                                onClick={this.GetEmployee}>
                                <i className="fa fa-search" aria-hidden="true"/>
                            </button>
                        </div>
                        <p className="form__input-error">Solo letras, min 3 y max 15.</p>
                        <p className="form__input-void">Nombre no puede ir vacio.</p>
                    </div>
                    {/*TIPO DE EMPLEADO*/}
                    <div className="col-6 mb-3" id="grupo__selectRole">
                        <div className="input-group ">
                            <div className="input-group-prepend form__group-input">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de usuario</span>
                            </div>
                            <select 
                                name="select" 
                                className="form-control form__input" 
                                id="selectRole"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={employeeModel.Role ? employeeModel.Role : ""}
                                onChange={this.ChangeRole}
                                onBlur={this.ValidateType}>
                                    <option value="---">Seleccionar</option>
                                    <option value="1">Administrador</option>
                                    
                            </select>
                        </div>
                        <p className="form__input-void">Tiene que seleccionar un tipo de usuario</p>
                    </div>
                </div>
                <div className="row"> 
                    {/*APELLIDO DEL EMPLEADO*/}
                    <div className="col-6 mb-3" id="grupo__lastName">
                        <div className="input-group">
                            <div className="input-group-prepend form__group-input">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Apellido</span>
                            </div>
                            <input type="text" className="form-control form__input"
                                id="User_LastName"
                                disabled={(action === 2 && !editMode) ? true : false}
                                onChange={this.ChangeLastName}
                                value={employeeModel.LastName ? employeeModel.LastName : ""}
                                onBlur={this.ValidateLastName}/>
                        </div>
                        <p className="form__input-error">Solo letras, min 3 y max 35.</p>
                        <p className="form__input-void">Apellido no puede ir vacio.</p>
                    </div>
                    {/*CONTRASEÑA DE EMPLEADO*/}
                    <div className="col-6 mb-3" id="grupo__password">
                        <div className="input-group">
                            <div className="input-group-prepend form__group-input">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña</span>
                            </div>
                                <input className="form-control form__input"
                                        id="User_Password"
                                        type={ typeVisibility === false ? 'text' : 'password' }
                                        disabled={(action === 2) ? true : false}
                                        onChange={this.ChangePassword}
                                        value={employeeModel.Password ? typeVisibility === false && action === 2 ? employeeModel.U_FMB_passwdDecrypt : employeeModel.Password : ""}
                                        onBlur={this.ValidatePassword}
                                />
                                <div className="input-group-prepend" style={{width: 40}}>
                                    <span className="input-group-text"  style={{background: ''}}
                                    onClick = {() => EyeVisibility()}><i className={typeVisibility === false ? 'fa fa-eye' : 'fa fa-eye-slash'}/></span>
                                </div>
                        </div>
                        <p className="form__input-void">La contraseña no puede estar vacia.</p>
                        {/*CAMBIAR CONTRASEÑA*/}
                        {(action === 2 && editMode) &&
                            <div className="input-group mb-3" style={{justifyContent:'space-around'}}>                            
                                <u data-toggle="modal" data-target="#changePasswordModal" onClick={OpenChangePasswordModal}>Cambiar contraseña</u>                 
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                    {/*CORREO DEL EMPLEADO*/}
                    <div className="col-6 mb-3" id="grupo__email">
                        <div className="input-group">
                            <div className="input-group-prepend form__group-input">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Correo</span>
                            </div>
                            <input type="email" className="form-control form__input"
                                disabled={(action === 2 && !editMode) ? true : false}
                                id="User_eMail"
                                onChange={this.Change_eMail}
                                value={employeeModel.eMail ? employeeModel.eMail : ""}
                                onBlur={this.ValidateE_mail}/>
                        </div>
                        <p className="form__input-error">Ingrese una dirección de correo electronico valido.</p>
                        <p className="form__input-void">Correo no puede ir vacio</p>
                    </div>
                    {/*SUCURSAL*/} 
                    <div className="col-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Sucursal</span>
                            </div>
                            <select 
                                name="select" 
                                className="form-control" 
                                id="selectSucursal"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={employeeModel.Sucursal ? employeeModel.Sucursal : ""}
                                onChange={this.ChangeSucursal}>
                                    <option value="---">Selecciona sucursal</option>
                                    {!!sucursales && sucursales.map(sucur => {
                                        return (
                                            <option value={sucur.pk_Sucursal}>{sucur.nombre}</option>
                                        )
                                    })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/*EMPLEADO ACTIVO*/}
                    <div className="col-6">
                        <div className="input-group mb-3">
                            <div className="col-md-12 col-sm-12" style={{marginTop: 20}}>
                                <div className="radio font-weight-bold" style={{fontSize: 13, marginTop: 0}}>
                                    <label>
                                        <input
                                            type="radio"
                                            name="optradio"
                                            disabled={(action === 2 && !editMode) ? true : false}
                                            checked={employeeModel.Active === 'Y' ? true : false}
                                            id="radio"
                                            onChange={() => this.ChangeActive('Y')}
                                            style={{marginRight:'5px'}}
                                        />{' '}
                                        Empleado activo
                                    </label>
                                </div>
                                <div className="radio font-weight-bold" style={{fontSize: 13, marginTop: 0}}>
                                    <label>
                                        <input
                                            type="radio"
                                            name="optradio"
                                            disabled={(action === 2 && !editMode) ? true : false}
                                            checked={employeeModel.Active === 'N' ? true : false}
                                            id="radio2"
                                            onChange={() => this.ChangeActive('N')}
                                            style={{marginRight:'5px'}}
                                        />{' '}
                                        Empleado inactivo
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*CLIENTE POR DEFECTO*/}
                    <div className="col-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                            </div>
                            <select 
                                name="select" 
                                className="form-control" 
                                id="selectCaja"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={employeeModel.CardCode ? employeeModel.CardCode : ""}
                                onChange={this.ChangeCardCode}>
                                    <option value="---">Seleccionar</option>
                                    {!!ListPartner && ListPartner.map(partner => {
                                        return (
                                            <option value={partner.CardCode}>{partner.CardName || 'Sin nombre' }</option>
                                        )
                                    })}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Caja</span>
                            </div>
                            <select 
                                name="select" 
                                className="form-control" 
                                id="selectCaja"
                                disabled={(action === 2 && !editMode) ? true : false}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                value={employeeModel.Caja ? employeeModel.Caja : ""}
                                onChange={this.ChangeCaja}>
                                    <option value="---">Seleccionar</option>
                                    <option value="1">Caja 1</option>
                                    <option value="2">Caja 2</option>
                            </select>
                        </div>
                    </div>
                </div>

                {showSearchEmployeeModal && 
                    <SearchEmployeeModal
                        employees={employees}
                        SearchOneEmployee={SearchOneEmployee}
                        CloseSearchEmployeeModal={CloseSearchEmployeeModal}
                    />
                }

            </div>
        )
    };

    renderEmployeeBody = () => {
        const {
            action,
            editMode,
            employeeModel,
            dataEmployee,
        } = this.props;

        let statesWork = [];
        let statesHome = [];
        if (employeeModel.WorkCountryCode !== '') {
            for (let index = 0; index < dataEmployee.states.length; index++) {
                const state = dataEmployee.states[index];
                if (state.Country === employeeModel.WorkCountryCode) {
                    statesWork.push(dataEmployee.states[index]);
                }
            }
            if (statesWork.length <= 0 ) {
                employeeModel.WorkStateCode = '';
            }
        }
        if (employeeModel.HomeCountry !== '') {
            for (let index = 0; index < dataEmployee.states.length; index++) {
                const state = dataEmployee.states[index];
                if (state.Country === employeeModel.HomeCountry) {
                    statesHome.push(dataEmployee.states[index]);
                }
            }
            if (statesHome.length <= 0 ) {
                employeeModel.HomeState = '';
            }
        }
        
        return (
            <div style={{marginTop: 30}}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Direccion"
                            data-toggle="tab"
                            href="#DatosMaestrosDireccion"
                            aria-controls="DatosMaestrosDireccion">
                            Dirección
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Personal"
                            data-toggle="tab"
                            href="#DatosMaestrosPersonal"
                            aria-controls="DatosMaestrosPersonal">
                            Personal
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{textAlign: 'left'}}>
                    {/* DIRECCIÓN */}
                    <div className="container tab-pane active"
                         id="DatosMaestrosDireccion"
                         aria-labelledby="nav-profile-tab-Direccion"
                         >
                        <div className="row col-sm col" style={{paddingRight: 0}}>
                            
                            {/*PRIMER COLUMNA*/}
                            <div className="col-12 col-md-6"><br></br>
                                <div className="input-group mb-3" style={{justifyContent:'space-around'}}>                            
                                    <u>Dirección de trabajo</u>
                                </div>
                                {/*CALLE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkStreet}
                                                value={employeeModel.WorkStreet ? employeeModel.WorkStreet : ""}/>
                                </div>
                                {/*NÚMERO DE CALLE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de calle</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkStreetNumber}
                                                value={employeeModel.WorkStreetNumber ? employeeModel.WorkStreetNumber : ""}/>
                                </div>
                                {/*BLOQUE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Bloque</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkBlock}
                                                value={employeeModel.WorkBlock ? employeeModel.WorkBlock : ""}/>
                                </div>
                                {/*EDIFICIO DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Edificio</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkBuildingFloorRoom}
                                                value={employeeModel.WorkBuildingFloorRoom ? employeeModel.WorkBuildingFloorRoom : ""}/>
                                </div>
                                {/*CÓDIGO POSTAL DEL EMPLEADO*/}
                                <div className="mb-3" id="grupo__pc">
                                    <div className="input-group">
                                        <div className="input-group-prepend form__group-input">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código postal</span>
                                        </div>
                                            <input type="text" className="form-control form__input"
                                                    id="User_PostalCode"
                                                    disabled={(action === 2 && !editMode) ? true : false}
                                                    onChange={this.ChangeWorkZipCode}
                                                    value={employeeModel.WorkZipCode ? employeeModel.WorkZipCode : ""}
                                                    onBlur={this.ValidatePostalCode}/>
                                    </div>
                                    <p className="form__input-error">Solo letras, min 3 y max 15.</p>
                                </div>
                                {/*CIUDAD DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Ciudad</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkCity}
                                                value={employeeModel.WorkCity ? employeeModel.WorkCity : ""}/>
                                </div>
                                {/*PROVINCIA DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Provincia</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeWorkCounty}
                                                value={employeeModel.WorkCounty ? employeeModel.WorkCounty : ""}/>
                                </div>
                                {/*ESTADO DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                    </div>
                                    <select 
                                        name="select" 
                                        className="form-control" 
                                        id="selectEstadoW"
                                        disabled={((action === 2 && !editMode) || (employeeModel.WorkCountryCode === '')) ? true : false}
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        value={employeeModel.WorkStateCode ? employeeModel.WorkStateCode : ""}
                                        onChange={this.ChangeWorkStateCode}>
                                            <option value="---">--Selecciona--</option>
                                            {!!statesWork && statesWork.map(state => {
                                                return (
                                                    <option value={state.Code}>{state.Name}</option>
                                                )
                                            })}
                                    </select>
                                </div>
                                {/*PAIS DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Pais</span>
                                    </div>
                                    <select 
                                        name="select" 
                                        className="form-control" 
                                        id="selectPaisW"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        value={employeeModel.WorkCountryCode ? employeeModel.WorkCountryCode : ""}
                                        onChange={this.ChangeWorkCountryCode}>
                                            <option value="---">--Selecciona--</option>
                                            {!!dataEmployee.country && dataEmployee.country.map(countr => {
                                                return (
                                                    <option value={countr.Code}>{countr.Name}</option>
                                                )
                                            })}
                                    </select>
                                </div>
                            </div>

                            {/*SEGUNDA COLUMNA*/}
                            <div className="col-sm" style={{paddingRight: 0}}><br></br>
                                <div className="input-group mb-3" style={{justifyContent:'space-around'}}>
                                    <u>Dirección de casa</u>
                                </div>
                                {/*CALLE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeStreet}
                                                value={employeeModel.HomeStreet ? employeeModel.HomeStreet : ""}/>
                                </div>
                                {/*NÚMERO DE CALLE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de calle</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeStreetNumber}
                                                value={employeeModel.HomeStreetNumber ? employeeModel.HomeStreetNumber : ""}/>
                                </div>
                                {/*BLOQUE DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Bloque</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeBlock}
                                                value={employeeModel.HomeBlock ? employeeModel.HomeBlock : ""}/>
                                </div>
                                {/*EDIFICIO DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Edificio</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeBuildingFloorRoom}
                                                value={employeeModel.HomeBuildingFloorRoom ? employeeModel.HomeBuildingFloorRoom : ""}/>
                                </div>
                                {/*CÓDIGO POSTAL DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Código postal</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeZipCode}
                                                value={employeeModel.HomeZipCode ? employeeModel.HomeZipCode : ""}/>
                                </div>
                                {/*CIUDAD DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Ciudad</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeCity}
                                                value={employeeModel.HomeCity ? employeeModel.HomeCity : ""}/>
                                </div>
                                {/*PROVINCIA DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Provincia</span>
                                    </div>
                                        <input type="text" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeHomeCounty}
                                                value={employeeModel.HomeCounty ? employeeModel.HomeCounty : ""}/>
                                </div>
                                {/*ESTADO DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                    </div>
                                    <select 
                                        name="select" 
                                        className="form-control" 
                                        id="selectEstadoW"
                                        disabled={((action === 2 && !editMode) || (employeeModel.HomeCountry === '')) ? true : false}
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        value={employeeModel.HomeState ? employeeModel.HomeState : ""}
                                        onChange={this.ChangeHomeState}>
                                            <option value="---">--Selecciona--</option>
                                            {!!statesHome && statesHome.map(state => {
                                                return (
                                                    <option value={state.Code}>{state.Name}</option>
                                                )
                                            })}
                                    </select>
                                </div>
                                {/*PAIS DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Pais</span>
                                    </div>
                                    <select 
                                        name="select" 
                                        className="form-control" 
                                        id="selectPaisW"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        value={employeeModel.HomeCountry ? employeeModel.HomeCountry : ""}
                                        onChange={this.ChangeHomeCountry}>
                                            <option value="---">--Selecciona--</option>
                                            {!!dataEmployee.country && dataEmployee.country.map(countr => {
                                                return (
                                                    <option value={countr.Code}>{countr.Name}</option>
                                                )
                                            })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* PERSONAL */}
                    <div className="container tab-pane fade"
                         id="DatosMaestrosPersonal"
                         aria-labelledby="nav-profile-tab-Personal"
                         >
                        <div className="row col-sm col" style={{paddingRight: 0}}>
                            {/*PRIMER COLUMNA*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*SEXO DE EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Sexo</span>
                                    </div>
                                        <select 
                                            name="select" 
                                            className="form-control" 
                                            id="selectRole"
                                            disabled={(action === 2 && !editMode) ? true : false}
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            value={employeeModel.Gender ? employeeModel.Gender : ""}
                                            onChange={this.ChangeGender}>
                                                <option value="E">No especificado</option>
                                                <option value="F">Femenino</option>
                                                <option value="M">Masculino</option>
                                        </select>
                                </div>
                                {/*FECHA DE NACIMIENTO DEL EMPLEADO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de nacimiento</span>
                                    </div>
                                        <input type="date" className="form-control"
                                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                id="User_LastName"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeDateOfBirth}
                                                max='9999-12-31'
                                                value={employeeModel.DateOfBirth ? employeeModel.DateOfBirth : ""}/>
                                </div>
                                {/*NUMERO DEL EMPLEADO*/}
                                <div className="mb-3" id="grupo__phone">
                                    <div className="input-group">
                                        <div className="input-group-prepend form__group-input">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Teléfono móvil</span>
                                        </div>
                                            <input type="tel" className="form-control form__input"
                                                id="User_Phone"
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                onChange={this.ChangeMobilePhone}
                                                value={employeeModel.MobilePhone ? employeeModel.MobilePhone : ""}
                                                onBlur={this.ValidatePhone}/>
                                    </div>
                                    <p className="form__input-error">Solo números y deben ser 10 digitos.</p>
                                </div>
                            </div>

                            {/*SEGUNDA COLUMNA*/}
                            <div className="col-sm" style={{paddingRight: 0}}><br></br>
                                

                            </div>
                        </div>
                    </div>              
                </div>
            </div>
        )
    }

    ChangeOldPassword = event => {
        const {employeeModel} = this.props;
        employeeModel.OldPassword = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeU_FMB_PasswdNew = event => {
        const {employeeModel} = this.props;
        employeeModel.U_FMB_passwdNew = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    ChangeU_FMB_Passwdconfirm = event => {
        const {employeeModel} = this.props;
        employeeModel.U_FMB_passwdConfirm = event.nativeEvent.target.value;
        this.refreshModel(employeeModel);
    };

    SaveChangePassword = async () => {
        const {employeeModel, changePassword} = this.props;
        changePassword(employeeModel);
    };
    
    render() {
        const {
            ShowEmployeeModal,
            action,
            editMode,
            showChangePasswordModal,
            employeeModel,
            typeVisibilityOld,
            typeVisibilitynew,
            typeVisibilityconfirm,
            EyeVisibilityOld,
            EyeVisibilityNew,
            EyeVisibilityConfirm,
            CloseChangePasswordModal
        } = this.props;
        
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll" id="employeeModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="employeeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content" role="document">
                        <div className="modal-header text-white" style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">REGISTRO DE EMPLEADOS</h4>                  
                            <button type="button" className="close" data-dismiss="modal" onClick={ShowEmployeeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.renderEditButton()}
                            {this.renderEmployeeHeader()}
                            {this.renderEmployeeBody()}
                        </div>
                        <div className="modal-footer">
                            {/* <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={ShowEmployeeModal}>Cancelar</button> */}
                            {/* <button type="button" className="btn btn-success" onClick={this.CreateEmployee}>Crear</button> */}                            
                            {action === 1 && 
                                <button type="button" className="btn botonCorrect text-black" onClick={this.CreateEmployee}> 
                                    Crear
                                    
                                </button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.AcceptEditMode}>
                                    Guardar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                            {/* {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger" onClick={this.OpenAreYouAgreeModal}>
                                    Eliminar
                                </button>
                            )} */}
                            <button type="button" className="btn botonCerrar text-white" data-dismiss="modal" onClick={ShowEmployeeModal}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {showChangePasswordModal &&
                    <ChangePasswordModal
                        action={action}
                        adminUsersModel={employeeModel}
                        editMode={editMode}
                        ChangeOldPassword={this.ChangeOldPassword}
                        ChangeU_FMB_PasswdNew={this.ChangeU_FMB_PasswdNew}
                        ChangeU_FMB_Passwdconfirm={this.ChangeU_FMB_Passwdconfirm}
                        EyeVisibilityOld={EyeVisibilityOld}
                        EyeVisibilityNew={EyeVisibilityNew}
                        EyeVisibilityConfirm={EyeVisibilityConfirm}
                        typeVisibilityOld={typeVisibilityOld}
                        typeVisibilitynew={typeVisibilitynew}
                        typeVisibilityconfirm={typeVisibilityconfirm}
                        SaveChangePassword={this.SaveChangePassword}
                        CloseChangePasswordModal={CloseChangePasswordModal}
                    />
                }
            </div>
        );
    }
}

export default EmployeeModal;